// extracted by mini-css-extract-plugin
export default {"FormWrapper":"project-item_FormWrapper__r4c6X","FormField--TwoCol":"project-item_FormField--TwoCol__WMB52","FormField--FullCol":"project-item_FormField--FullCol__KsKyt"};